<template>
    <div>
        <div id="portal-header" class="unselectable">
            <div id="login-logo"></div>
        </div>
        <div class="login-sso-message">
            {{ $t('LOGIN_MESSAGE_' + code.toString()) }}
        </div>
    </div>
</template>

<script>
    import './resources/styles/login.scss';

    export default {
        name: 'Message',
        props: {
            code: {
                type: Number,
                required: true,
            },
        },
        created() {
            if (
                !Object.keys(this.$i18n.messages[this.$i18n.locale]).includes('LOGIN_MESSAGE_' + this.code.toString())
            ) {
                this.$router.push('/login');
            }
        },
    };
</script>
